import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fontawesome';
import './client/utils/extraCurrencies';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { setupUSDSymbol } from './client/CurrencyToText';
import { ErrorBoundary } from 'react-error-boundary';

import { ColorModeProvider } from './ColorModeContext';


setupUSDSymbol('US$');

function logError(error, info) {
    if (window.location.hostname === 'localhost') return;

    const org = window.location.pathname.split('/')[2];
    const path = window.location.href;
    
    // Handle cases where error might not be an Error object
    let errorMessage = '';
    let errorStack = '';
    
    if (error instanceof Error) {
        errorMessage = error.message || '';
        errorStack = error.stack || '';
    } else if (error && typeof error === 'object') {
        // Try to extract message from error object
        errorMessage = error.message || error.toString() || JSON.stringify(error);
        errorStack = error.stack || '';
    } else if (error !== null && error !== undefined) {
        // Convert non-Error values to string
        errorMessage = String(error);
        errorStack = '';
    }
    
    // Safely extract email from window.me
    const userEmail = (window.me && window.me.email) ? window.me.email : '';
    
    const iframe = document.createElement('iframe');
    iframe.src = `/error?path=${encodeURIComponent(path)}&org=${encodeURIComponent(org)}&reason=${encodeURIComponent(errorMessage)}&stack=${encodeURIComponent(errorStack)}&me=${encodeURIComponent(userEmail)}`;
    iframe.style.position = 'fixed';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.border = 'none';
    iframe.style.zIndex = '9999999';
    document.body.appendChild(iframe);
}

window.addEventListener('unhandledrejection', (event) => {
    logError(event.reason);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ColorModeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DndProvider backend={HTML5Backend}>
                <ErrorBoundary fallback={<div />} onError={logError}>
                    <App />
                </ErrorBoundary>
            </DndProvider>
        </LocalizationProvider>
    </ColorModeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
